module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_customer_service_KPI-5af5a234d9bcf1f448bcf00e81078fa6.png";